export default "__VITE_PUBLIC_ASSET__9809ee31__"